import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPersonalInfo } from '../../services/Auth/personalInfoService';
import { getDetalleByParametroId } from '../../services/Admin/detalleParametroService';
import Sidebar from '../../components/Sidebar';
import SoporteLayout from '../../layouts/SoporteLayout';
import { jwtDecode } from 'jwt-decode';
import '../tasks/CrearTareaPage.css'; // Reutilizar estilos
import '../styles/FormPageStyles.css';
import withAuth from '../../routes/withAuth';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombres: '',
    apellidos: '',
    tipoDocumento: '',
    numeroDocumento: '',
    celular: '',
    email: '',
    cargoId: '',
  });
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // --- Sidebar Logic ---
  const links = [
    { to: '/home', label: 'Home'},
    { to: '/admin/parametros', label: 'Parametros' },
    { to: '/admin/area', label: 'Area' },
    { to: '/admin/categoria', label: 'Categoria' },
    { to: '/admin/rol', label: 'Rol' },
    { to: '/admin/tareas-area', label: 'Tareas del Área' },
    { to: '/tareas-calificacion', label: 'Tareas por Calificación' },
    { to: '/admin/estadisticas', label: 'Estadísticas' },
    { to: '/auth/register', label: 'Crear Usuario' },
    { to: '/admin/administrar-usuarios', label: 'Administrar Usuarios' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };
  // --- End Sidebar Logic ---

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Cargar tipos de documento
        const tiposData = await getDetalleByParametroId(1);
        setTiposDocumento(tiposData || []);
        
        // Cargar cargos
        const cargosData = await getDetalleByParametroId(6);
        setCargos(cargosData || []);
      } catch (err) {
        setError('Error al cargar datos iniciales.');
        console.error(err);
        setTiposDocumento([]);
        setCargos([]);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    if (!formData.nombres || !formData.apellidos || !formData.tipoDocumento || !formData.numeroDocumento || !formData.celular || !formData.email) {
      setError('Todos los campos son obligatorios.');
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await createPersonalInfo(formData);
      if (result.success) {
        setSuccessMessage('¡Información guardada! Redirigiendo para asignar rol y contraseña...');
        setTimeout(() => navigate('/auth/user'), 2000);
      } else {
        setError(result.message || 'Error al registrar. Intente de nuevo.');
      }
    } catch (err) {
      setError('Error al enviar el formulario. Verifique la consola.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Detectar si el usuario es soporte técnico
  const isSoporte = (() => {
    const token = localStorage.getItem('authToken');
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      return decoded.rolId === '3';
    } catch {
      return false;
    }
  })();

  const content = (
    <div className="form-wrapper">
      <h2>Paso 1: Registrar Información Personal</h2>
      {error && <p className="error-message">{error}</p>}
      {successMessage && <p className="success-message">{successMessage}</p>}
      <form onSubmit={handleSubmit} className="grid-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="nombres">Nombres*</label>
            <input type="text" id="nombres" name="nombres" value={formData.nombres} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="apellidos">Apellidos*</label>
            <input type="text" id="apellidos" name="apellidos" value={formData.apellidos} onChange={handleChange} required />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="tipoDocumento">Tipo de Documento*</label>
            <select id="tipoDocumento" name="tipoDocumento" value={formData.tipoDocumento} onChange={handleChange} required>
              <option value="" disabled>Seleccione...</option>
              {tiposDocumento.map(tipo => (
                <option key={tipo.id_detaparametro} value={tipo.id_detaparametro}>{tipo.valor}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="numeroDocumento">Número de Documento*</label>
            <input type="text" id="numeroDocumento" name="numeroDocumento" value={formData.numeroDocumento} onChange={handleChange} required />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="celular">Celular*</label>
            <input type="text" id="celular" name="celular" value={formData.celular} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="cargoId">Cargo (Opcional)</label>
            <select id="cargoId" name="cargoId" value={formData.cargoId} onChange={handleChange}>
              <option value="">Seleccione un cargo...</option>
              {cargos.map(cargo => (
                <option key={cargo.id_detaparametro} value={cargo.id_detaparametro}>{cargo.valor}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-row">
          <button type="submit" className="submit-button create-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Guardando...' : 'Siguiente Paso'}
          </button>
        </div>
      </form>
    </div>
  );

  if (isSoporte) {
    return <SoporteLayout>{content}</SoporteLayout>;
  }

  return (
    <div className="crear-tarea-container">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="crear-tarea-content">
        {content}
      </main>
    </div>
  );
};

export default withAuth(RegisterPage); 